import { FaInfoCircle } from "react-icons/fa";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type Props = {
	totalAttendances: number;
	averageAttendancesPerDay: number;
	evasions: number;
	evasionsPercentage: number;
	obitos: number;
	obitos_ate_24h: number;
	obitos_maior_24h: number;
	maxDay: number;
	minDay: number;
	por_turno: Array<{ total: number; turno: string }>;
};

export function ReceptionDashboardCards({
	totalAttendances,
	averageAttendancesPerDay,
	evasions,
	evasionsPercentage,
	obitos,
	obitos_ate_24h,
	obitos_maior_24h,
	maxDay,
	minDay,
	por_turno,
}: Props) {
	return (
		<>
			<Row className="px-0 py-2 bg-white justify-content-evenly rounded">
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Total de pacientes recepcionados"
						value={totalAttendances.toLocaleString()}
						classNameCard="m-2 rounded p-2 bg-primary h-100"
						classNameTitle="text-white text-center"
						classNameValue="text-white"
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-white" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Média de pacientes recepcionados"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						value={averageAttendancesPerDay.toLocaleString()}
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Evasões de pacientes recepcionados"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={evasions.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="% de evasões"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={`${evasionsPercentage.toLocaleString()} %`}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
			</Row>
			<Row className="px-0 py-2 bg-white justify-content-evenly rounded mt-3">
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Óbitos"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={obitos.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Óbitos até 24h"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={obitos_ate_24h.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Óbitos maior que 24h"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={obitos_maior_24h.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Máximo de atendimentos em 1 dia"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={maxDay.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Mínimo de atendimentos em 1 dia"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={minDay.toLocaleString()}
						metaData={
							<CardOverlayTrigger
								header=""
								message=""
								icon={<FaInfoCircle className="text-muted" />}
							/>
						}
					/>
				</Col>
			</Row>
		</>
	);
}
